import * as Views from "./views";


const Module = {
    name: "cashflowrecords",
    defaultRoutePath: "/cashflows/cashflowrecord",
    menuItemScope: "cashflows",
    menuItemName: "cashflowrecords",
    routes: [
        {
            path: "/cashflows/cashflowrecord",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Views.Default,
                },
                {
                    path: "list",
                    Component: Views.List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: Views.List,
        },
        {
            path: "detail",
            Component: Views.Detail,
        },
        {
            path: "create",
            Component: Views.Create,
        },
    ],

}

export default Module;
